import { CheckboxStyled } from '../CheckboxStyled';
import styled from 'styled-components';
import { rem } from 'polished';

export const CheckboxStyledAP = styled(CheckboxStyled)`
    font-size: ${({ theme }) => theme.fontSizes.textBase};
`;
